import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmModal } from '@app/shared/modals';
import { AppFilter } from '@app/shared/models';
import { SuiModalService, ModalSize } from '@richardlt/ng2-semantic-ui';
import { Location } from '@angular/common';
import { environment } from 'src/environments/environment';
import { OrganizationService } from 'src/modules/features/admin/services';
import { DocumentService } from 'src/modules/features/contractor/services';
import { DocumentTypeService } from 'src/modules/features/setting/services';
import { PdfViewerService } from 'src/modules/features/contractor/services/pdfViewer';

@Component({
  selector: 'app-archived-document',
  templateUrl: './archived-document.component.html',
  styleUrls: ['./archived-document.component.scss'],
})
export class ArchivedDocumentComponent implements OnInit {
  documents = [];
  projectId: string;
  success: any;
  error: any;
  pending: boolean;
  filter: AppFilter = new AppFilter();
  totalItems: number = 0;
  rows: number = 2;
  currentPage: number = 1;
  maxSize: number = 7;
  organizationId: string;
  isAttachmentView: boolean = false;
  activeDocuments;
  searchFilters = {
    groupOp: 'AND',
    rules: [
      {
        field: 'documentId.documentName',
        op: 'cn',
        data: '',
      },
    ],
  };
  baseUrl = environment.API_SERVER;

  constructor(
    private modalService: SuiModalService,
    private router: Router,
    private organizationSvc: OrganizationService,
    private documentSvc: DocumentService,
    private pdfViewerService: PdfViewerService
  ) {
    this.documents = [
      {
        createdBy:
          '{"appUserId":"62b1f08e-2f70-46fa-a182-bc8ed95d3acb","username":"mtn-nigeria","name":"Musa Mensah","organizationId":"3fdcd697-a3ee-4bb3-8b91-11b030fcb269","organizationName":"MTN Nigeria"}',
        dateCreated: '2022-09-13T08:43:50.586+0000',
        dateModified: null,
        deleted: false,
        modifiedBy: null,
        organizationDocumentId: '3a9bac2c-6eff-4a46-9375-65442c869c9c',
        organizationId: '3fdcd697-a3ee-4bb3-8b91-11b030fcb269',
        status: 'pending',
        documentId: {
          attachment: false,
          byteSize: 490063,
          createdBy:
            '{"appUserId":"62b1f08e-2f70-46fa-a182-bc8ed95d3acb","username":"mtn-nigeria","name":"Musa Mensah","organizationId":"3fdcd697-a3ee-4bb3-8b91-11b030fcb269","organizationName":"MTN Nigeria"}',
          dateCreated: '2022-09-13T08:43:50.337+0000',
          dateModified: null,
          documentDescription: null,
          documentId: '3bdd0454-ac93-4fb2-ae83-167654729e6d',
          documentName: 'CAC DOC 2',
          documentPath:
            '2022-09/files/4cxRdxqwSv______individual_Licence_Application_Form.pdf',
          documentTypeId: {
            createdBy:
              '{"appUserId":"ncc-admin","username":"ncc-admin","name":"NCC ADMIN Super","organizationId":"ncc","organizationName":"Nigerian Communications Commission "}',
            dateCreated: '2022-01-31T18:43:23.710+0000',
            dateModified: '2022-03-17T10:03:17.929+0000',
            documentTypeId: '289f9c5d-d6b3-440c-a12e-4cd664da6597',
            documentTypeName: 'CAC Document',
            group: null,
            isRequired: false,
            modifiedBy:
              '{"appUserId":"ncc-admin","username":"ncc-admin","name":"NCC ADMIN  Super","organizationId":"ncc","organizationName":"Nigerian Communications Commission "}',
            extension: 'application',
          },
          extension: 'application',
          extensionGroup: 'pdf',
          modifiedBy: null,
        },
      },
    ];
    this.organizationId = window.localStorage.getItem('organizationId');

    this.filter = new AppFilter({ sidx: 'dateCreated' });
    this.getPage(1);
  }

  ngOnInit(): void {}

  getPage(page: number) {
    this.filter.page = page;
    this.pending = true;
    if (this.isAttachmentView === false) {
      // this.searchFilters.rules[0].field = 'documentId.attachment';
      // this.searchFilters.rules[0].data = 'false';
      // this.filter.filters = JSON.stringify(this.searchFilters);
    } else {
      // this.searchFilters.rules[0].field = 'documentId.attachment';
      // this.searchFilters.rules[0].data = 'true';
      // this.filter.filters = JSON.stringify(this.searchFilters);
    }
    this.documentSvc
      .getDocument({
        organizationId: this.organizationId,
        status: 'ARCHIVED',
        params: this.filter,
      })
      .subscribe(
        (res: any) => {
          this.pending = false;
          this.totalItems = +res.records;
          this.rows = this.filter.rows;
          this.documents = res['rows'];
          const groupedObjects = this.documents.reduce((result, obj) => {
            const key = obj.documentId.documentTypeId.documentTypeName;
            if (!result[key]) {
              result[key] = [];
            }
            result[key].push(obj);
            return result;
          }, {});

          this.activeDocuments = Object.entries(groupedObjects).map(
            ([key, value]) => ({ key, value })
          );
          this.appendCollapseState(this.activeDocuments);
          this.totalItems = this.activeDocuments.length;
          console.log(this.activeDocuments, 'arrayOfGroups');
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error
            ? error.error
            : error;
        }
      );
  }
  toggleAffiliateTypesVisibility(index: number) {
    this.activeDocuments[index]['isCollapsed'] =
      !this.activeDocuments[index]['isCollapsed'];
  }
  appendCollapseState(data) {
    this.activeDocuments.forEach((record) => {
      record['isCollapsed'] = true;
    });
  }
  onArchive(item) {
    this.modalService
      .open(
        new ConfirmModal(
          'Archive Document?',
          'Are you sure you want to restore this document from archive?',
          ModalSize.Tiny
        )
      )
      .onApprove(() => {
        this.archiveDocument(item);
      })
      .onDeny(() => {});
  }

  archiveDocument(val) {
    this.pending = true;
    this.documentSvc
      .updateDocument({
        docId: val.organizationDocumentId,
        status: 'ACTIVE',
        organizationId: this.organizationId,
      })
      .subscribe(
        (res) => {
          this.pending = false;
          this.success = 'Document successfully restored';

          setTimeout(() => {
            this.router.navigateByUrl('/contractor/company/document/official');
          }, 1000);
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error
            ? error.error
            : error;
        }
      );
  }

  searchRecords(search) {
    this.searchFilters.rules[0].data = search;
    this.filter.filters = JSON.stringify(this.searchFilters);
    this.getPage(1);
  }

  //handle sorting records
  sortRecords(search) {
    this.filter.sord = search;
    this.getPage(1);
  }

  //handles rows display
  displayRecords(row) {
    this.filter['rows'] = row;
    this.getPage(1);
  }

  nextPage(page: number) {
    //get and assign current page
    this.currentPage = page;
    this.getPage(this.currentPage);
  }

  delete(event: any): void {
    this.pending = true;
    this.error = null;
    this.documentSvc
      .removeDocument({
        organizationId: this.organizationId,
        id: event.organizationDocumentId,
      })
      .subscribe(
        (res) => {
          this.pending = false;
          this.success =
            'Document removed successfully. You will be notified when your changes are verified';
          this.getPage(this.filter.page);
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error
            ? error.error
            : error;
        }
      );
  }

  onDelete(event) {
    this.modalService
      .open(
        new ConfirmModal(
          'Remove Document?',
          'Are you sure you want to remove document?',
          ModalSize.Tiny
        )
      )
      .onApprove(() => {
        this.delete(event);
      })
      .onDeny(() => {});
  }

  view(payload) {
    console.log(payload);
    if (payload.documentId.extension == 'image') {
      this.pdfViewerService.viewPdf(payload.documentId, 'image');
      // url = `${this.baseUrl}/public/image/?media=${payload.documentId.documentPath}`;
    } else {
      this.pdfViewerService.viewPdf(payload.documentId);
    }
    // fetch(url).then(function (t) {
    //   return t.blob().then((b) => {
    //     var a = document.createElement('a');
    //     a.href = URL.createObjectURL(b);
    //     a.setAttribute(
    //       'download',
    //       `${payload.documentId.documentPath}.${payload.documentId.extensionGroup}`
    //     );
    //     a.click();
    //   });
    // });
  }
  download(payload) {
    console.log(payload);
    let url;
    if (payload.documentId.extension == 'image') {
      url = `${this.baseUrl}/public/image/?media=${payload.documentId.documentPath}`;
    } else {
      url = `${this.baseUrl}/public/media/?media=${payload.documentId.documentPath}`;
    }
    fetch(url).then(function (t) {
      return t.blob().then((b) => {
        var a = document.createElement('a');
        a.href = URL.createObjectURL(b);
        a.setAttribute(
          'download',
          `${payload.documentId.documentPath}.${payload.documentId.extensionGroup}`
        );
        a.click();
      });
    });
  }
}
